import React, { FC, useContext } from 'react';
import OfficePageContextProvider from '../Context/OfficePageContext';
import OfficePageNew from './OfficePageNew';
import BrokerProfilePageNew from './BrokerProfilePageNew';
import '@splidejs/splide/dist/css/splide.min.css';

type Props = {
  pageId?: string;
  archiveId?: string;
};

const OfficePageProvider: FC<Props> = ({ pageId, archiveId }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const brokerQueryFromSearch = searchParams?.get('broker');

  const pathname = window.location.pathname;
  const pathSegments = pathname.split('/');
  const medarbetareIndex = pathSegments.indexOf('medarbetare');
  const brokerQueryFromPath =
    medarbetareIndex !== -1
      ? decodeURIComponent(pathSegments[medarbetareIndex + 1])
      : null;

  const brokerQuery = brokerQueryFromSearch || brokerQueryFromPath;

  return (
    <OfficePageContextProvider pageId={pageId} archiveId={archiveId}>
      {brokerQuery ? (
        <BrokerProfilePageNew brokerQuery={brokerQuery} />
      ) : (
        <OfficePageNew />
      )}
    </OfficePageContextProvider>
  );
};

export default OfficePageProvider;
